import { render, staticRenderFns } from "./LoadingIndicator.vue?vue&type=template&id=3638e65e&scoped=true"
import script from "./LoadingIndicator.vue?vue&type=script&lang=js"
export * from "./LoadingIndicator.vue?vue&type=script&lang=js"
import style0 from "./LoadingIndicator.vue?vue&type=style&index=0&id=3638e65e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3638e65e",
  null
  
)

export default component.exports